// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"b70bed7d14980ced","513":"b70bed7d14980ced","888":"74131f3d56cb00fc"}[chunkId] + ".css";
};